// extracted by mini-css-extract-plugin
export default {"wrapper":"typedropdown_wrapper__orlSP","btnDropdown":"typedropdown_btnDropdown__nl-CD"};